import { render } from "./CalculationsPanel.vue?vue&type=template&id=5372fd7d"
import script from "./CalculationsPanel.vue?vue&type=script&lang=js"
export * from "./CalculationsPanel.vue?vue&type=script&lang=js"

import "./CalculationsPanel.vue?vue&type=style&index=0&id=5372fd7d&lang=scss"
script.render = render

export default script